/* Century filters (after oliverandblake.com), on top of Dawn's facets.js and menu drawer.
   1. <century-facet-more>: "Show all 17 colours" / "Show all 23 footwear sizes". Dawn re-renders a filter's list
      after every tick, so the open/closed choice is remembered and re-applied when the new list connects.
   2. Phone panel: every filter group stays open (Dawn's drawer closes nested <details> when the panel closes).
   3. Phone panel: the black button reads "Show 42 results" and follows the live product count. */
(() => {
  const openGroups = (window.centuryFacetOpen = window.centuryFacetOpen || new Set());

  if (!customElements.get('century-facet-more')) {
    customElements.define(
      'century-facet-more',
      class extends HTMLElement {
        connectedCallback() {
          this.list = this.closest('ul');
          this.toggle = this.querySelector('.century-facet-more');
          if (!this.list || !this.toggle) return;
          const filter = this.closest('.js-filter');
          this.key = `${filter ? filter.id : ''}:${this.dataset.group}`;
          this.set(openGroups.has(this.key));
          this.toggle.addEventListener('click', () => this.set(!this.isOpen));
          this.toggle.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            this.set(!this.isOpen);
          });
        }

        set(open) {
          this.isOpen = open;
          this.list.classList.toggle(`century-open-${this.dataset.group}`, open);
          this.toggle.setAttribute('aria-expanded', String(open));
          this.toggle.textContent = open ? this.toggle.dataset.less : this.toggle.dataset.more;
          open ? openGroups.add(this.key) : openGroups.delete(this.key);
        }
      }
    );
  }

  // Price slider (snippets/price-facet): two range handles over the "$ from to $ to" boxes. Moving a handle writes
  // the box, and the box's input event lets Dawn's form filter as usual; typing in a box moves the handle.
  if (!customElements.get('century-price-slider')) {
    customElements.define(
      'century-price-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.max = Number(this.dataset.max) || 1;
          this.lo = this.querySelector('[data-price-lo]');
          this.hi = this.querySelector('[data-price-hi]');
          this.fill = this.querySelector('.century-price__fill');
          const boxes = this.closest('price-range, .facets__price').querySelectorAll('.century-price__input');
          this.loBox = boxes[0];
          this.hiBox = boxes[1];
          if (!this.lo || !this.hi || !this.loBox || !this.hiBox) return;

          const onSlide = (event) => {
            let lo = Number(this.lo.value);
            let hi = Number(this.hi.value);
            if (lo > hi) {
              if (event.target === this.lo) this.lo.value = lo = hi;
              else this.hi.value = hi = lo;
            }
            // A handle at its end means "no limit", so the box is left empty.
            this.loBox.value = lo > 0 ? lo : '';
            this.hiBox.value = hi < this.max ? hi : '';
            this.paint();
          };
          this.lo.addEventListener('input', onSlide);
          this.hi.addEventListener('input', onSlide);

          const onType = () => {
            const lo = parseFloat(this.loBox.value.replace(/,/g, ''));
            const hi = parseFloat(this.hiBox.value.replace(/,/g, ''));
            this.lo.value = Number.isNaN(lo) ? 0 : Math.max(0, Math.min(lo, this.max));
            this.hi.value = Number.isNaN(hi) ? this.max : Math.max(0, Math.min(hi, this.max));
            this.paint();
          };
          this.loBox.addEventListener('input', onType);
          this.hiBox.addEventListener('input', onType);
          this.paint();
        }

        paint() {
          const lo = (Number(this.lo.value) / this.max) * 100;
          const hi = (Number(this.hi.value) / this.max) * 100;
          this.fill.style.left = `${lo}%`;
          this.fill.style.width = `${Math.max(hi - lo, 0)}%`;
          // Keep the low handle grabbable when both sit at the right end.
          this.lo.style.zIndex = Number(this.lo.value) >= this.max - 1 ? 3 : 2;
        }
      }
    );
  }

  const openAllGroups = (root = document) => {
    root.querySelectorAll('#FacetFiltersFormMobile details.mobile-facets__details').forEach((details) => {
      details.open = true;
    });
  };

  // Re-open the groups whenever the phone panel opens.
  document.addEventListener(
    'toggle',
    (event) => {
      if (event.target.classList && event.target.classList.contains('mobile-facets__disclosure') && event.target.open) {
        openAllGroups();
      }
    },
    true
  );

  const updateResultsLabel = () => {
    const count = document.getElementById('ProductCount');
    if (!count) return;
    const n = parseInt(count.dataset.productCount, 10);
    if (Number.isNaN(n)) return;
    document.querySelectorAll('.century-results-label').forEach((label) => {
      label.textContent = n === 1 ? 'Show 1 result' : `Show ${n} results`;
    });
  };

  const start = () => {
    openAllGroups();
    updateResultsLabel();
    const count = document.getElementById('ProductCount');
    if (count) {
      new MutationObserver(updateResultsLabel).observe(count, {
        attributes: true,
        attributeFilter: ['data-product-count'],
        childList: true,
      });
    }
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
